import * as common from 'store/modules/common'
import { api } from './api'

export const prefix = 'fileAttachments'

export { api }
export const initialState = { ...common.initialState }
export const actionTypes = {
  ...common.actionTypes(prefix)
}
export const actionCreators = {
  ...common.actionCreators(prefix, api)
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    default: return common.reducer(state, action, prefix)
  }
}
